import { engravingMessageMaxLength } from '../constants';
export var validateEngravingMessageLength = function (message) {
    return message.length <= engravingMessageMaxLength;
};
